export default __webpack_public_path__ + "static/media/icon-camera.533a40de.svg";